import { defineStore } from "pinia";
import { ref } from "vue";
import { API } from "@/queries/index";
import { AxiosError } from "axios";
import { APIResponse, APIResponseError } from "@/types/api";
import { handleResponse, handleResponseError } from "@/utils/api";
import { LogActivityResponseInterface } from "@/types/interface/log-activity";

export const useLogActivityStore = defineStore("logActivityStore", () => {
  const log = ref<LogActivityResponseInterface>();
  const logs = ref<LogActivityResponseInterface[]>([]);

  function initLogs(data: any) {
    logs.value = data?.data;
  }

  function addNewLog(data: any) {
    log.value = data;
  }

  async function dispatchGetList(page = 1, limit = 10, queryParam = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.logActivity.getLogActivity(page, limit, queryParam);
      initLogs(data);
      return handleResponse(status, data);
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
  }

  async function dispatchDetail(idLogActivity = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.logActivity.findLogActivity(idLogActivity);
      addNewLog(data);
      return handleResponse(status, data);
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
  }

  return {
    log,
    logs,
    initLogs,
    dispatchDetail,
    dispatchGetList
  };
});